import { ArrowLeft, ArrowRight } from "lucide-react";
import { SLIDE_META } from "./config";

const NavBtn = ({ onClick, disabled, label, testId, children, primary }) => (
  <button
    onClick={onClick}
    disabled={disabled}
    aria-label={label}
    data-testid={testId}
    className={`group grid h-11 w-11 place-items-center rounded-full border transition-[background-color,border-color,color,transform] duration-300 disabled:pointer-events-none disabled:opacity-30 active:scale-95 ${
      primary
        ? "border-[var(--dash)] bg-[var(--dash)] text-black hover:bg-[#ff8a33]"
        : "border-white/15 bg-black/40 text-zinc-100 backdrop-blur-md hover:border-white/40"
    }`}
  >
    {children}
  </button>
);

export const DeckNav = ({ index, go }) => (
  <nav
    className="fixed inset-x-0 bottom-0 z-50 flex items-center justify-between gap-4 bg-gradient-to-t from-[#07080b] via-[#07080b]/85 to-transparent px-5 pb-5 pt-8 sm:px-8 lg:px-14"
    data-testid="deck-nav"
  >
    <p className="font-mono-d text-[11px] uppercase tracking-[0.22em] text-zinc-400" data-testid="slide-counter">
      <span className="text-zinc-50">{String(index + 1).padStart(2, "0")}</span> / 08
      <span className="ml-3 hidden text-zinc-300 sm:inline">{SLIDE_META[index].label}</span>
    </p>
    <div className="hidden items-center gap-2 md:flex">
      {SLIDE_META.map((s, i) => (
        <button
          key={s.key}
          onClick={() => go(i)}
          aria-label={`Go to ${s.label}`}
          data-testid={`slide-dot-${i + 1}`}
          className={`h-1.5 rounded-full transition-[width,background-color] duration-500 ${
            i === index ? "w-10 bg-[var(--dash)]" : "w-3 bg-zinc-600 hover:bg-zinc-400"
          }`}
        />
      ))}
    </div>
    <div className="flex items-center gap-3">
      <span className="hidden font-mono-d text-[11px] uppercase tracking-[0.2em] text-zinc-500 lg:inline">← → keys</span>
      <NavBtn onClick={() => go(index - 1)} disabled={index === 0} label="Previous slide" testId="slide-prev-button">
        <ArrowLeft size={18} />
      </NavBtn>
      <NavBtn onClick={() => go(index + 1)} disabled={index === 7} label="Next slide" testId="slide-next-button" primary>
        <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-0.5" />
      </NavBtn>
    </div>
  </nav>
);
